import * as Operations from '~/graphql/__generated__/operations';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;


export function useAiAllCoursesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AiAllCoursesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AiAllCoursesQuery, Operations.AiAllCoursesQueryVariables | undefined>({ query: Operations.AiAllCoursesDocument, variables: undefined, ...options });
};

export function useAiTopicsForCourseQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AiTopicsForCourseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AiTopicsForCourseQuery, Operations.AiTopicsForCourseQueryVariables | undefined>({ query: Operations.AiTopicsForCourseDocument, variables: undefined, ...options });
};

export function useAiSettingsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AiSettingsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AiSettingsQuery, Operations.AiSettingsQueryVariables | undefined>({ query: Operations.AiSettingsDocument, variables: undefined, ...options });
};

export function useCreateAiSettingsForCourseMutation() {
  return Urql.useMutation<Operations.CreateAiSettingsForCourseMutation, Operations.CreateAiSettingsForCourseMutationVariables>(Operations.CreateAiSettingsForCourseDocument);
};

export function useCurriculumContentQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CurriculumContentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CurriculumContentQuery, Operations.CurriculumContentQueryVariables | undefined>({ query: Operations.CurriculumContentDocument, variables: undefined, ...options });
};

export function useCurriculumsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CurriculumsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CurriculumsQuery, Operations.CurriculumsQueryVariables | undefined>({ query: Operations.CurriculumsDocument, variables: undefined, ...options });
};

export function useUpdateAiSettingsForCourseMutation() {
  return Urql.useMutation<Operations.UpdateAiSettingsForCourseMutation, Operations.UpdateAiSettingsForCourseMutationVariables>(Operations.UpdateAiSettingsForCourseDocument);
};

export function useAiToolTextToSpeechMutation() {
  return Urql.useMutation<Operations.AiToolTextToSpeechMutation, Operations.AiToolTextToSpeechMutationVariables>(Operations.AiToolTextToSpeechDocument);
};

export function useAiTasksQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AiTasksQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AiTasksQuery, Operations.AiTasksQueryVariables | undefined>({ query: Operations.AiTasksDocument, variables: undefined, ...options });
};

export function useChangePasswordMutation() {
  return Urql.useMutation<Operations.ChangePasswordMutation, Operations.ChangePasswordMutationVariables>(Operations.ChangePasswordDocument);
};

export function useEmailSignupMutation() {
  return Urql.useMutation<Operations.EmailSignupMutation, Operations.EmailSignupMutationVariables>(Operations.EmailSignupDocument);
};

export function useLoginMutation() {
  return Urql.useMutation<Operations.LoginMutation, Operations.LoginMutationVariables>(Operations.LoginDocument);
};

export function useRefreshTokenMutation() {
  return Urql.useMutation<Operations.RefreshTokenMutation, Operations.RefreshTokenMutationVariables>(Operations.RefreshTokenDocument);
};

export function useRequestUserPasswordResetMutation() {
  return Urql.useMutation<Operations.RequestUserPasswordResetMutation, Operations.RequestUserPasswordResetMutationVariables>(Operations.RequestUserPasswordResetDocument);
};

export function useRequestVerificationEmailMutation() {
  return Urql.useMutation<Operations.RequestVerificationEmailMutation, Operations.RequestVerificationEmailMutationVariables>(Operations.RequestVerificationEmailDocument);
};

export function useSsoSignupMutation() {
  return Urql.useMutation<Operations.SsoSignupMutation, Operations.SsoSignupMutationVariables>(Operations.SsoSignupDocument);
};

export function useUpdateUserEmailMutation() {
  return Urql.useMutation<Operations.UpdateUserEmailMutation, Operations.UpdateUserEmailMutationVariables>(Operations.UpdateUserEmailDocument);
};

export function useUpdateUserMutation() {
  return Urql.useMutation<Operations.UpdateUserMutation, Operations.UpdateUserMutationVariables>(Operations.UpdateUserDocument);
};

export function useVerifyUserEmailMutation() {
  return Urql.useMutation<Operations.VerifyUserEmailMutation, Operations.VerifyUserEmailMutationVariables>(Operations.VerifyUserEmailDocument);
};

export function useVerifyUserPasswordResetMutation() {
  return Urql.useMutation<Operations.VerifyUserPasswordResetMutation, Operations.VerifyUserPasswordResetMutationVariables>(Operations.VerifyUserPasswordResetDocument);
};

export function useAddCalendarEventMutation() {
  return Urql.useMutation<Operations.AddCalendarEventMutation, Operations.AddCalendarEventMutationVariables>(Operations.AddCalendarEventDocument);
};

export function useAddCalendarEventsMutation() {
  return Urql.useMutation<Operations.AddCalendarEventsMutation, Operations.AddCalendarEventsMutationVariables>(Operations.AddCalendarEventsDocument);
};

export function useAddCalendarNoteMutation() {
  return Urql.useMutation<Operations.AddCalendarNoteMutation, Operations.AddCalendarNoteMutationVariables>(Operations.AddCalendarNoteDocument);
};

export function useCalendarDaysQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CalendarDaysQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CalendarDaysQuery, Operations.CalendarDaysQueryVariables | undefined>({ query: Operations.CalendarDaysDocument, variables: undefined, ...options });
};

export function useMoveCalendarEventMutation() {
  return Urql.useMutation<Operations.MoveCalendarEventMutation, Operations.MoveCalendarEventMutationVariables>(Operations.MoveCalendarEventDocument);
};

export function usePresentationQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PresentationQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PresentationQuery, Operations.PresentationQueryVariables | undefined>({ query: Operations.PresentationDocument, variables: undefined, ...options });
};

export function usePublicCourseCalendarDaysQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicCourseCalendarDaysQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicCourseCalendarDaysQuery, Operations.PublicCourseCalendarDaysQueryVariables | undefined>({ query: Operations.PublicCourseCalendarDaysDocument, variables: undefined, ...options });
};

export function useRemoveCalendarEventMutation() {
  return Urql.useMutation<Operations.RemoveCalendarEventMutation, Operations.RemoveCalendarEventMutationVariables>(Operations.RemoveCalendarEventDocument);
};

export function useUpdateCalendarNoteMutation() {
  return Urql.useMutation<Operations.UpdateCalendarNoteMutation, Operations.UpdateCalendarNoteMutationVariables>(Operations.UpdateCalendarNoteDocument);
};

export function useUserCalendarDaysQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.UserCalendarDaysQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.UserCalendarDaysQuery, Operations.UserCalendarDaysQueryVariables | undefined>({ query: Operations.UserCalendarDaysDocument, variables: undefined, ...options });
};

export function useAcceptCourseCollaborationInviteMutation() {
  return Urql.useMutation<Operations.AcceptCourseCollaborationInviteMutation, Operations.AcceptCourseCollaborationInviteMutationVariables>(Operations.AcceptCourseCollaborationInviteDocument);
};

export function useAddCollaboratorMutation() {
  return Urql.useMutation<Operations.AddCollaboratorMutation, Operations.AddCollaboratorMutationVariables>(Operations.AddCollaboratorDocument);
};

export function useCourseCollaboratorsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CourseCollaboratorsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CourseCollaboratorsQuery, Operations.CourseCollaboratorsQueryVariables | undefined>({ query: Operations.CourseCollaboratorsDocument, variables: undefined, ...options });
};

export function useCourseInvitePreviewQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CourseInvitePreviewQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CourseInvitePreviewQuery, Operations.CourseInvitePreviewQueryVariables | undefined>({ query: Operations.CourseInvitePreviewDocument, variables: undefined, ...options });
};

export function useCreateCourseCollaborationInviteMutation() {
  return Urql.useMutation<Operations.CreateCourseCollaborationInviteMutation, Operations.CreateCourseCollaborationInviteMutationVariables>(Operations.CreateCourseCollaborationInviteDocument);
};

export function useInvalidateCourseCollaborationInviteMutation() {
  return Urql.useMutation<Operations.InvalidateCourseCollaborationInviteMutation, Operations.InvalidateCourseCollaborationInviteMutationVariables>(Operations.InvalidateCourseCollaborationInviteDocument);
};

export function useRemoveCourseCollaboratorMutation() {
  return Urql.useMutation<Operations.RemoveCourseCollaboratorMutation, Operations.RemoveCourseCollaboratorMutationVariables>(Operations.RemoveCourseCollaboratorDocument);
};

export function useUpdateCourseCollaboratorMutation() {
  return Urql.useMutation<Operations.UpdateCourseCollaboratorMutation, Operations.UpdateCourseCollaboratorMutationVariables>(Operations.UpdateCourseCollaboratorDocument);
};

export function useCoursePublicAccessQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CoursePublicAccessQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CoursePublicAccessQuery, Operations.CoursePublicAccessQueryVariables | undefined>({ query: Operations.CoursePublicAccessDocument, variables: undefined, ...options });
};

export function useCreateCoursePublicAccessMutation() {
  return Urql.useMutation<Operations.CreateCoursePublicAccessMutation, Operations.CreateCoursePublicAccessMutationVariables>(Operations.CreateCoursePublicAccessDocument);
};

export function useInvalidateCoursePublicAccessMutation() {
  return Urql.useMutation<Operations.InvalidateCoursePublicAccessMutation, Operations.InvalidateCoursePublicAccessMutationVariables>(Operations.InvalidateCoursePublicAccessDocument);
};

export function usePublicCourseQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicCourseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicCourseQuery, Operations.PublicCourseQueryVariables | undefined>({ query: Operations.PublicCourseDocument, variables: undefined, ...options });
};

export function useCloseCourseMutation() {
  return Urql.useMutation<Operations.CloseCourseMutation, Operations.CloseCourseMutationVariables>(Operations.CloseCourseDocument);
};

export function useCoursesForTopicQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CoursesForTopicQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CoursesForTopicQuery, Operations.CoursesForTopicQueryVariables | undefined>({ query: Operations.CoursesForTopicDocument, variables: undefined, ...options });
};

export function useCourseWithTopicInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CourseWithTopicInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CourseWithTopicInstancesQuery, Operations.CourseWithTopicInstancesQueryVariables | undefined>({ query: Operations.CourseWithTopicInstancesDocument, variables: undefined, ...options });
};

export function useCourseQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.CourseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.CourseQuery, Operations.CourseQueryVariables | undefined>({ query: Operations.CourseDocument, variables: undefined, ...options });
};

export function useCreateCourseMutation() {
  return Urql.useMutation<Operations.CreateCourseMutation, Operations.CreateCourseMutationVariables>(Operations.CreateCourseDocument);
};

export function useMyCoursesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.MyCoursesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.MyCoursesQuery, Operations.MyCoursesQueryVariables | undefined>({ query: Operations.MyCoursesDocument, variables: undefined, ...options });
};

export function useNewCourseDataQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.NewCourseDataQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.NewCourseDataQuery, Operations.NewCourseDataQueryVariables | undefined>({ query: Operations.NewCourseDataDocument, variables: undefined, ...options });
};

export function useReorderCourseMutation() {
  return Urql.useMutation<Operations.ReorderCourseMutation, Operations.ReorderCourseMutationVariables>(Operations.ReorderCourseDocument);
};

export function useUpdateCourseMutation() {
  return Urql.useMutation<Operations.UpdateCourseMutation, Operations.UpdateCourseMutationVariables>(Operations.UpdateCourseDocument);
};

export function useEmailNotificationSubscriptionsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.EmailNotificationSubscriptionsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.EmailNotificationSubscriptionsQuery, Operations.EmailNotificationSubscriptionsQueryVariables | undefined>({ query: Operations.EmailNotificationSubscriptionsDocument, variables: undefined, ...options });
};

export function useUpdateEmailNotificationSubscriptionMutation() {
  return Urql.useMutation<Operations.UpdateEmailNotificationSubscriptionMutation, Operations.UpdateEmailNotificationSubscriptionMutationVariables>(Operations.UpdateEmailNotificationSubscriptionDocument);
};

export function useFeatureFlagsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.FeatureFlagsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.FeatureFlagsQuery, Operations.FeatureFlagsQueryVariables | undefined>({ query: Operations.FeatureFlagsDocument, variables: undefined, ...options });
};

export function usePushOnboardingProgressMutation() {
  return Urql.useMutation<Operations.PushOnboardingProgressMutation, Operations.PushOnboardingProgressMutationVariables>(Operations.PushOnboardingProgressDocument);
};

export function useCheckExistingExternalCoursesMutation() {
  return Urql.useMutation<Operations.CheckExistingExternalCoursesMutation, Operations.CheckExistingExternalCoursesMutationVariables>(Operations.CheckExistingExternalCoursesDocument);
};

export function useConnectExternalCourseMutation() {
  return Urql.useMutation<Operations.ConnectExternalCourseMutation, Operations.ConnectExternalCourseMutationVariables>(Operations.ConnectExternalCourseDocument);
};

export function useConnectExternalIntegrationMutation() {
  return Urql.useMutation<Operations.ConnectExternalIntegrationMutation, Operations.ConnectExternalIntegrationMutationVariables>(Operations.ConnectExternalIntegrationDocument);
};

export function useDisonnectExternalCourseMutation() {
  return Urql.useMutation<Operations.DisonnectExternalCourseMutation, Operations.DisonnectExternalCourseMutationVariables>(Operations.DisonnectExternalCourseDocument);
};

export function useDisconnectExternalIntegrationMutation() {
  return Urql.useMutation<Operations.DisconnectExternalIntegrationMutation, Operations.DisconnectExternalIntegrationMutationVariables>(Operations.DisconnectExternalIntegrationDocument);
};

export function useExternalCoursesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ExternalCoursesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ExternalCoursesQuery, Operations.ExternalCoursesQueryVariables | undefined>({ query: Operations.ExternalCoursesDocument, variables: undefined, ...options });
};

export function useExternalIntegrationsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ExternalIntegrationsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ExternalIntegrationsQuery, Operations.ExternalIntegrationsQueryVariables | undefined>({ query: Operations.ExternalIntegrationsDocument, variables: undefined, ...options });
};

export function useIgnoreExternalCourseMutation() {
  return Urql.useMutation<Operations.IgnoreExternalCourseMutation, Operations.IgnoreExternalCourseMutationVariables>(Operations.IgnoreExternalCourseDocument);
};

export function useIntegrationCheckMutation() {
  return Urql.useMutation<Operations.IntegrationCheckMutation, Operations.IntegrationCheckMutationVariables>(Operations.IntegrationCheckDocument);
};

export function useJoinExistingExternalCourseMutation() {
  return Urql.useMutation<Operations.JoinExistingExternalCourseMutation, Operations.JoinExistingExternalCourseMutationVariables>(Operations.JoinExistingExternalCourseDocument);
};

export function usePushLessonToExternalSourceMutation() {
  return Urql.useMutation<Operations.PushLessonToExternalSourceMutation, Operations.PushLessonToExternalSourceMutationVariables>(Operations.PushLessonToExternalSourceDocument);
};

export function useUnIngnoreExternalCourseMutation() {
  return Urql.useMutation<Operations.UnIngnoreExternalCourseMutation, Operations.UnIngnoreExternalCourseMutationVariables>(Operations.UnIngnoreExternalCourseDocument);
};

export function useItemInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ItemInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ItemInstancesQuery, Operations.ItemInstancesQueryVariables | undefined>({ query: Operations.ItemInstancesDocument, variables: undefined, ...options });
};

export function usePublicItemInstanceQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicItemInstanceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicItemInstanceQuery, Operations.PublicItemInstanceQueryVariables | undefined>({ query: Operations.PublicItemInstanceDocument, variables: undefined, ...options });
};

export function usePublicItemInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicItemInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicItemInstancesQuery, Operations.PublicItemInstancesQueryVariables | undefined>({ query: Operations.PublicItemInstancesDocument, variables: undefined, ...options });
};

export function useSearchItemInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.SearchItemInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.SearchItemInstancesQuery, Operations.SearchItemInstancesQueryVariables | undefined>({ query: Operations.SearchItemInstancesDocument, variables: undefined, ...options });
};

export function useToggleItemInstanceVisibilityMutation() {
  return Urql.useMutation<Operations.ToggleItemInstanceVisibilityMutation, Operations.ToggleItemInstanceVisibilityMutationVariables>(Operations.ToggleItemInstanceVisibilityDocument);
};

export function useCreateMaterialMutation() {
  return Urql.useMutation<Operations.CreateMaterialMutation, Operations.CreateMaterialMutationVariables>(Operations.CreateMaterialDocument);
};

export function useDuplicateItemsMutation() {
  return Urql.useMutation<Operations.DuplicateItemsMutation, Operations.DuplicateItemsMutationVariables>(Operations.DuplicateItemsDocument);
};

export function useItemQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ItemQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ItemQuery, Operations.ItemQueryVariables | undefined>({ query: Operations.ItemDocument, variables: undefined, ...options });
};

export function useItemsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ItemsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ItemsQuery, Operations.ItemsQueryVariables | undefined>({ query: Operations.ItemsDocument, variables: undefined, ...options });
};

export function usePublicItemQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicItemQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicItemQuery, Operations.PublicItemQueryVariables | undefined>({ query: Operations.PublicItemDocument, variables: undefined, ...options });
};

export function useRemoveItemMutation() {
  return Urql.useMutation<Operations.RemoveItemMutation, Operations.RemoveItemMutationVariables>(Operations.RemoveItemDocument);
};

export function useReorderItemMutation() {
  return Urql.useMutation<Operations.ReorderItemMutation, Operations.ReorderItemMutationVariables>(Operations.ReorderItemDocument);
};

export function useUpdateItemMutation() {
  return Urql.useMutation<Operations.UpdateItemMutation, Operations.UpdateItemMutationVariables>(Operations.UpdateItemDocument);
};

export function useAllItemsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AllItemsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AllItemsQuery, Operations.AllItemsQueryVariables | undefined>({ query: Operations.AllItemsDocument, variables: undefined, ...options });
};

export function useAllTopicsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.AllTopicsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.AllTopicsQuery, Operations.AllTopicsQueryVariables | undefined>({ query: Operations.AllTopicsDocument, variables: undefined, ...options });
};

export function useExportLibraryMutation() {
  return Urql.useMutation<Operations.ExportLibraryMutation, Operations.ExportLibraryMutationVariables>(Operations.ExportLibraryDocument);
};

export function useItemDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ItemDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ItemDetailsQuery, Operations.ItemDetailsQueryVariables | undefined>({ query: Operations.ItemDetailsDocument, variables: undefined, ...options });
};

export function useLibraryTopicQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.LibraryTopicQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.LibraryTopicQuery, Operations.LibraryTopicQueryVariables | undefined>({ query: Operations.LibraryTopicDocument, variables: undefined, ...options });
};

export function useNewItemsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.NewItemsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.NewItemsQuery, Operations.NewItemsQueryVariables | undefined>({ query: Operations.NewItemsDocument, variables: undefined, ...options });
};

export function useNewTopicsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.NewTopicsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.NewTopicsQuery, Operations.NewTopicsQueryVariables | undefined>({ query: Operations.NewTopicsDocument, variables: undefined, ...options });
};

export function useSearchLibraryQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.SearchLibraryQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.SearchLibraryQuery, Operations.SearchLibraryQueryVariables | undefined>({ query: Operations.SearchLibraryDocument, variables: undefined, ...options });
};

export function useTopicDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicDetailsQuery, Operations.TopicDetailsQueryVariables | undefined>({ query: Operations.TopicDetailsDocument, variables: undefined, ...options });
};

export function useAddItemToCalendarMutation() {
  return Urql.useMutation<Operations.AddItemToCalendarMutation, Operations.AddItemToCalendarMutationVariables>(Operations.AddItemToCalendarDocument);
};

export function useItemSyncDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.ItemSyncDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.ItemSyncDetailsQuery, Operations.ItemSyncDetailsQueryVariables | undefined>({ query: Operations.ItemSyncDetailsDocument, variables: undefined, ...options });
};

export function useSyncItemInfoFromItemTemplateMutation() {
  return Urql.useMutation<Operations.SyncItemInfoFromItemTemplateMutation, Operations.SyncItemInfoFromItemTemplateMutationVariables>(Operations.SyncItemInfoFromItemTemplateDocument);
};

export function useSyncNewItemsFromTopicTemplateMutation() {
  return Urql.useMutation<Operations.SyncNewItemsFromTopicTemplateMutation, Operations.SyncNewItemsFromTopicTemplateMutationVariables>(Operations.SyncNewItemsFromTopicTemplateDocument);
};

export function useSyncNewSnippetsFromItemTemplateMutation() {
  return Urql.useMutation<Operations.SyncNewSnippetsFromItemTemplateMutation, Operations.SyncNewSnippetsFromItemTemplateMutationVariables>(Operations.SyncNewSnippetsFromItemTemplateDocument);
};

export function useSyncTopicInfoFromTopicTemplateMutation() {
  return Urql.useMutation<Operations.SyncTopicInfoFromTopicTemplateMutation, Operations.SyncTopicInfoFromTopicTemplateMutationVariables>(Operations.SyncTopicInfoFromTopicTemplateDocument);
};

export function useTopicSyncDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicSyncDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicSyncDetailsQuery, Operations.TopicSyncDetailsQueryVariables | undefined>({ query: Operations.TopicSyncDetailsDocument, variables: undefined, ...options });
};

export function useAcceptTenantInviteMutation() {
  return Urql.useMutation<Operations.AcceptTenantInviteMutation, Operations.AcceptTenantInviteMutationVariables>(Operations.AcceptTenantInviteDocument);
};

export function useTenantInvitePreviewQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TenantInvitePreviewQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TenantInvitePreviewQuery, Operations.TenantInvitePreviewQueryVariables | undefined>({ query: Operations.TenantInvitePreviewDocument, variables: undefined, ...options });
};

export function useTenantMembersQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TenantMembersQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TenantMembersQuery, Operations.TenantMembersQueryVariables | undefined>({ query: Operations.TenantMembersDocument, variables: undefined, ...options });
};

export function useAddTimetableExtensionMutation() {
  return Urql.useMutation<Operations.AddTimetableExtensionMutation, Operations.AddTimetableExtensionMutationVariables>(Operations.AddTimetableExtensionDocument);
};

export function usePushEntireUserTimetableMutation() {
  return Urql.useMutation<Operations.PushEntireUserTimetableMutation, Operations.PushEntireUserTimetableMutationVariables>(Operations.PushEntireUserTimetableDocument);
};

export function useRemoveTimetableExtensionMutation() {
  return Urql.useMutation<Operations.RemoveTimetableExtensionMutation, Operations.RemoveTimetableExtensionMutationVariables>(Operations.RemoveTimetableExtensionDocument);
};

export function useTimetableEditorQuickQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetableEditorQuickQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetableEditorQuickQuery, Operations.TimetableEditorQuickQueryVariables | undefined>({ query: Operations.TimetableEditorQuickDocument, variables: undefined, ...options });
};

export function useTimetableExtensionQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetableExtensionQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetableExtensionQuery, Operations.TimetableExtensionQueryVariables | undefined>({ query: Operations.TimetableExtensionDocument, variables: undefined, ...options });
};

export function useTimetableExtensionsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetableExtensionsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetableExtensionsQuery, Operations.TimetableExtensionsQueryVariables | undefined>({ query: Operations.TimetableExtensionsDocument, variables: undefined, ...options });
};

export function useTimetableForUserQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetableForUserQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetableForUserQuery, Operations.TimetableForUserQueryVariables | undefined>({ query: Operations.TimetableForUserDocument, variables: undefined, ...options });
};

export function useTimetablePeriodAlternativesForCourseQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetablePeriodAlternativesForCourseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetablePeriodAlternativesForCourseQuery, Operations.TimetablePeriodAlternativesForCourseQueryVariables | undefined>({ query: Operations.TimetablePeriodAlternativesForCourseDocument, variables: undefined, ...options });
};

export function useTimetableStructureQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TimetableStructureQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TimetableStructureQuery, Operations.TimetableStructureQueryVariables | undefined>({ query: Operations.TimetableStructureDocument, variables: undefined, ...options });
};

export function useUpdateTimetableExtensionMutation() {
  return Urql.useMutation<Operations.UpdateTimetableExtensionMutation, Operations.UpdateTimetableExtensionMutationVariables>(Operations.UpdateTimetableExtensionDocument);
};

export function useCreateTodoMutation() {
  return Urql.useMutation<Operations.CreateTodoMutation, Operations.CreateTodoMutationVariables>(Operations.CreateTodoDocument);
};

export function useDeleteTodoMutation() {
  return Urql.useMutation<Operations.DeleteTodoMutation, Operations.DeleteTodoMutationVariables>(Operations.DeleteTodoDocument);
};

export function useGetAllTodosQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.GetAllTodosQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.GetAllTodosQuery, Operations.GetAllTodosQueryVariables | undefined>({ query: Operations.GetAllTodosDocument, variables: undefined, ...options });
};

export function useGetDueTodosQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.GetDueTodosQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.GetDueTodosQuery, Operations.GetDueTodosQueryVariables | undefined>({ query: Operations.GetDueTodosDocument, variables: undefined, ...options });
};

export function useUpdateTodoMutation() {
  return Urql.useMutation<Operations.UpdateTodoMutation, Operations.UpdateTodoMutationVariables>(Operations.UpdateTodoDocument);
};

export function useCreateTopicInstanceMutation() {
  return Urql.useMutation<Operations.CreateTopicInstanceMutation, Operations.CreateTopicInstanceMutationVariables>(Operations.CreateTopicInstanceDocument);
};

export function usePublicTopicInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicTopicInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicTopicInstancesQuery, Operations.PublicTopicInstancesQueryVariables | undefined>({ query: Operations.PublicTopicInstancesDocument, variables: undefined, ...options });
};

export function useRemoveTopicInstanceMutation() {
  return Urql.useMutation<Operations.RemoveTopicInstanceMutation, Operations.RemoveTopicInstanceMutationVariables>(Operations.RemoveTopicInstanceDocument);
};

export function useReorderTopicInstanceMutation() {
  return Urql.useMutation<Operations.ReorderTopicInstanceMutation, Operations.ReorderTopicInstanceMutationVariables>(Operations.ReorderTopicInstanceDocument);
};

export function useSearchTopicsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.SearchTopicsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.SearchTopicsQuery, Operations.SearchTopicsQueryVariables | undefined>({ query: Operations.SearchTopicsDocument, variables: undefined, ...options });
};

export function useTopicInstanceForTopicInCourseQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicInstanceForTopicInCourseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicInstanceForTopicInCourseQuery, Operations.TopicInstanceForTopicInCourseQueryVariables | undefined>({ query: Operations.TopicInstanceForTopicInCourseDocument, variables: undefined, ...options });
};

export function useTopicInstanceQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicInstanceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicInstanceQuery, Operations.TopicInstanceQueryVariables | undefined>({ query: Operations.TopicInstanceDocument, variables: undefined, ...options });
};

export function useTopicInstancesQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicInstancesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicInstancesQuery, Operations.TopicInstancesQueryVariables | undefined>({ query: Operations.TopicInstancesDocument, variables: undefined, ...options });
};

export function useUpdateTopicInstanceMutation() {
  return Urql.useMutation<Operations.UpdateTopicInstanceMutation, Operations.UpdateTopicInstanceMutationVariables>(Operations.UpdateTopicInstanceDocument);
};

export function useAddTopicsToCoursesMutation() {
  return Urql.useMutation<Operations.AddTopicsToCoursesMutation, Operations.AddTopicsToCoursesMutationVariables>(Operations.AddTopicsToCoursesDocument);
};

export function useCreateTopicMutation() {
  return Urql.useMutation<Operations.CreateTopicMutation, Operations.CreateTopicMutationVariables>(Operations.CreateTopicDocument);
};

export function useDuplicateTopicsMutation() {
  return Urql.useMutation<Operations.DuplicateTopicsMutation, Operations.DuplicateTopicsMutationVariables>(Operations.DuplicateTopicsDocument);
};

export function usePublicTopicQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.PublicTopicQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.PublicTopicQuery, Operations.PublicTopicQueryVariables | undefined>({ query: Operations.PublicTopicDocument, variables: undefined, ...options });
};

export function useRemoveTopicMutation() {
  return Urql.useMutation<Operations.RemoveTopicMutation, Operations.RemoveTopicMutationVariables>(Operations.RemoveTopicDocument);
};

export function useReorderTopicMutation() {
  return Urql.useMutation<Operations.ReorderTopicMutation, Operations.ReorderTopicMutationVariables>(Operations.ReorderTopicDocument);
};

export function useTopicQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicQuery, Operations.TopicQueryVariables | undefined>({ query: Operations.TopicDocument, variables: undefined, ...options });
};

export function useTopicsQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.TopicsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.TopicsQuery, Operations.TopicsQueryVariables | undefined>({ query: Operations.TopicsDocument, variables: undefined, ...options });
};

export function useUpdateTopicMutation() {
  return Urql.useMutation<Operations.UpdateTopicMutation, Operations.UpdateTopicMutationVariables>(Operations.UpdateTopicDocument);
};

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<never, Operations.MeQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<Operations.MeQuery, Operations.MeQueryVariables | undefined>({ query: Operations.MeDocument, variables: undefined, ...options });
};

export function useRequestCheckoutSessionDataMutation() {
  return Urql.useMutation<Operations.RequestCheckoutSessionDataMutation, Operations.RequestCheckoutSessionDataMutationVariables>(Operations.RequestCheckoutSessionDataDocument);
};

export function useRequestPaymentGatewayPortalDataMutation() {
  return Urql.useMutation<Operations.RequestPaymentGatewayPortalDataMutation, Operations.RequestPaymentGatewayPortalDataMutationVariables>(Operations.RequestPaymentGatewayPortalDataDocument);
};

export function useUpdateUserPreferencesMutation() {
  return Urql.useMutation<Operations.UpdateUserPreferencesMutation, Operations.UpdateUserPreferencesMutationVariables>(Operations.UpdateUserPreferencesDocument);
};